import React, { useState } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import TrackingAnalysisDetails from './TrackingAnalysisDetails';
import './TrackingAnalysisCell.scss';

const MediaInfo = ({ trackingAnalysis }) => {
  const [showTrackingAnalysisPopup, setShowTrackingAnalysisPopup] = useState(false);

  return trackingAnalysis ? (
    <>
      <Box className="trackingAnalysisButton">
        <Button onClick={() => setShowTrackingAnalysisPopup(true)}>
          <VisibilityIcon /> View media supply details
        </Button>
      </Box>

      <Dialog open={showTrackingAnalysisPopup} onClose={() => setShowTrackingAnalysisPopup(false)}>
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <Box flexGrow={1}>Media Supply Details</Box>
            <Box>
              <IconButton onClick={() => setShowTrackingAnalysisPopup(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          <TrackingAnalysisDetails trackingAnalysis={trackingAnalysis} />
        </DialogContent>
      </Dialog>
    </>
  ) : (
    <p>N/A</p>
  );
};

export default React.memo(MediaInfo);
